export const PRIMARY = '#49161F';
export const BACKGROUND = '#EDEAE5';
export const DARK_BACKGROUND = '#E2DED7';

export const WHITE = '#FFFFFF';
export const BLACK = '#000000';
